import { render, staticRenderFns } from "./CompanyContractorCard.vue?vue&type=template&id=1d1cc744"
import script from "./CompanyContractorCard.vue?vue&type=script&lang=ts"
export * from "./CompanyContractorCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d1cc744')) {
      api.createRecord('1d1cc744', component.options)
    } else {
      api.reload('1d1cc744', component.options)
    }
    module.hot.accept("./CompanyContractorCard.vue?vue&type=template&id=1d1cc744", function () {
      api.rerender('1d1cc744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/CompanyContractorCard.vue"
export default component.exports